export const photoAlbums = [

  {
    id: "thailand-island-hopping",
    name: "Thailand Island Hopping",
    thumb: "thailand-island-hopping.jpeg",
    url: "https://onedrive.live.com/photos?photosData=%2Falbum%2F3441A0B7058E365B%21sc755c4af54534293821d17f9f41b1f5d",
    date: new Date("2026-08-30"),
    labels: ["snorkelling"],
    continents: ["Asia"],
    countries: ["Thailand"],
    cities: ["Koh Samui", "Koh Tao", "Koh Phangan"],
    public: false
  },
  {
    id: "ikos-oceania-greece",
    name: "Ikos Oceania Greece",
    thumb: "ikos-oceania-greece.jpeg",
    url: "https://onedrive.live.com/?view=8&photosData=%2Falbum%2F3441A0B7058E365B%21s7d6cf18720384a12a5ca302a75a6a1a4",
    date: new Date("2026-05-30"),
    labels: ["ikos"],
    continents: ["Europe"],
    countries: ["Greece"],
    cities: ["Thessaloniki"],
    public: false
  },
  {
    id: "2025-in-pictures",
    name: "2025 In Pictures",
    thumb: "2025.jpeg",
    url: "https://onedrive.live.com/?view=8&photosData=%2Falbum%2F3441A0B7058E365B%21sc03abe4ebeca4393a952e38576e0bf9e",
    date: new Date("2025-12-31"),
    labels: ["retrospective"],
    continents: [],
    countries: [],
    cities: [],
    public: false
  },
  {
    id: "jamaica",
    name: "Jamaica Hurricane Melissa",
    thumb: "jamaica2025.jpeg",
    url: "https://onedrive.live.com/?view=8&photosData=%2Falbum%2F3441A0B7058E365B%21sfac0ad4cb8b949218c2fe148fd17e178",
    date: new Date("2025-12-31"),
    labels: ["Hurricane Melissa"],
    continents: ["North America"],
    countries: ["Jamaica"],
    cities: [],
    public: false
  },
  {
    id: "corfu-albania-paxos",
    name: "Corfu, Albania and Paxos",
    thumb: "albania2025.jpeg",
    url: "https://onedrive.live.com/?view=8&photosData=%2Falbum%2F3441A0B7058E365B%21sb2b776f83d2042af8e0a9b119a98d002",
    date: new Date("2025-12-31"),
    labels: ["corfu", "paxos"],
    continents: ["Europe"],
    countries: ["Albania", "Greece"],
    cities: [],
    public: false
  },
  {
    id: "2024-in-pictures",
    name: "2024 In Pictures",
    thumb: "2024.jpeg",
    url: "https://photos.onedrive.com/album/3441A0B7058E365B!122986",
    date: new Date("2024-12-31"),
    labels: ["retrospective"],
    continents: [],
    countries: [],
    cities: [],
    public: false
  },
  {
    id: "legoland-billund",
    name: "Legoland Billund",
    thumb: "legolandbillund.jpeg",
    url: "https://photos.onedrive.com/album/3441A0B7058E365B!122266",
    date: new Date("2024-12-16"),
    labels: ["lego"],
    continents: ["Europe"],
    countries: ["Denmark"],
    cities: ["Billund"],
    public: false
  },
  {
    id: "mexico-2024",
    name: "Mexico 2024",
    thumb: "mexico2024.jpeg",
    url: "https://onedrive.live.com/?id=%2Fpersonal%2F3441a0b7058e365b%2FDocuments%2Fphotos%2Fcamera%2F2024%2FMexico%202024&sortField=LinkFilename&isAscending=true&viewid=5b39f9d0%2D94a5%2D46c9%2D9a9b%2D660451aa701b&view=0",
    date: new Date("2024-09-02"),
    labels: [],
    continents: ["North America"],
    countries: ["Mexico"],
    cities: [],
    public: false
  },
  {
    id: "mexico-xcaret-2024",
    name: "Mexico Xcaret 2024",
    thumb: "xcaret2024.jpeg",
    url: "https://onedrive.live.com/?id=%2Fpersonal%2F3441a0b7058e365b%2FDocuments%2Fphotos%2Fcamera%2F2024%2FMexico%202024%2FXcaret&sortField=LinkFilename&isAscending=true&viewid=5b39f9d0%2D94a5%2D46c9%2D9a9b%2D660451aa701b&view=0",
    date: new Date("2023-09-02"),
    labels: ["nature"],
    continents: ["North America"],
    countries: ["Mexico"],
    cities: [],
    public: false
  },
  {
    id: "2023-in-pictures",
    name: "2023 In Pictures",
    thumb: "2023.jpeg",
    url: "https://photos.onedrive.com/album/3441A0B7058E365B!117990",
    date: new Date("2023-12-31"),
    labels: ["retrospective"],
    continents: [],
    countries: [],
    cities: [],
    public: false
  },
  {
    id: "bali23",
    name: "Bali",
    thumb: "bali23.jpeg",
    url: "http://photos.onedrive.com/album/3441A0B7058E365B!114345",
    date: new Date("2023-09-02"),
    labels: [],
    continents: ["Asia"],
    countries: ["Indonesia"],
    cities: ["Bali"],
    public: false
  },
  {
    id: "domrep23",
    name: "Dominican Republic",
    thumb: "domrep23.jpeg",
    url: "http://photos.onedrive.com/album/3441A0B7058E365B!114344",
    date: new Date("2023-06-04"),
    labels: ["dominican republic"],
    continents: ["South America", "North America"],
    countries: [],
    cities: [],
    public: false
  },
  {
    id: "cyprus23",
    name: "Cyprus",
    thumb: "cyprus23.jpeg",
    url: "http://photos.onedrive.com/album/3441A0B7058E365B!114069",
    date: new Date("2023-04-07"),
    labels: [],
    continents: ["Europe"],
    countries: ["Cyprus"],
    cities: [],
    public: false
  },
  {
    id: "2022-in-pictures",
    name: "2022 In Pictures",
    thumb: "2022.jpeg",
    url: "http://photos.onedrive.com/album/3441A0B7058E365B!112353",
    date: new Date("2022-12-31"),
    labels: ["retrospective"],
    continents: [],
    countries: [],
    cities: [],
    public: false
  },
  {
    id: "maldives",
    name: "Maldives",
    thumb: "maldives.jpeg",
    url: "https://onedrive.live.com/?view=8&photosData=%2Falbum%2F3441A0B7058E365B%21111938",
    date: new Date("2022-06-04"),
    labels: [],
    continents: ["Asia"],
    countries: ["Maldives"],
    cities: [],
    public: false
  },
  {
    id: "2021-in-pictures",
    name: "2021 In Pictures",
    thumb: "2021.jpeg",
    url: "https://onedrive.live.com/?view=8&photosData=%2Falbum%2F3441A0B7058E365B%21111896",
    date: new Date("2021-12-31"),
    labels: ["retrospective"],
    continents: [],
    countries: [],
    cities: [],
    public: false
  },
  {
    id: "2020-in-pictures",
    name: "2020 In Pictures",
    thumb: "2020.jpeg",
    url: "https://onedrive.live.com/?view=8&photosData=%2Falbum%2F3441A0B7058E365B%21111897",
    date: new Date("2020-12-31"),
    labels: ["retrospective"],
    continents: [],
    countries: [],
    cities: [],
    public: false
  },
  {
    id: "2019-in-pictures",
    name: "2019 In Pictures",
    thumb: "2019.jpeg",
    url: "https://onedrive.live.com/?view=8&photosData=%2Falbum%2F3441A0B7058E365B%21111911",
    date: new Date("2019-12-31"),
    labels: ["retrospective"],
    continents: [],
    countries: [],
    cities: [],
    public: false
  },
  {
    id: "namibia",
    name: "Namibia",
    thumb: "namibia.jpeg",
    url: "https://onedrive.live.com/?view=8&photosData=%2Falbum%2F3441A0B7058E365B%21111929",
    date: new Date("2019-12-14"),
    labels: [],
    continents: ["Africa"],
    countries: ["Namibia"],
    cities: [],
    public: false
  },
  {
    id: "2018-in-pictures",
    name: "2018 In Pictures",
    thumb: "2018.jpeg",
    url: "https://onedrive.live.com/?view=8&photosData=%2Falbum%2F3441A0B7058E365B%21111912",
    date: new Date("2018-12-31"),
    labels: ["retrospective"],
    continents: [],
    countries: [],
    cities: [],
    public: false
  },
  {
    id: "barbados-cruise",
    name: "Barbados & Cruise",
    thumb: "barbados.jpeg",
    url: "https://onedrive.live.com/?view=8&photosData=%2Falbum%2F3441A0B7058E365B%21111926",
    date: new Date("2018-11-16"),
    labels: [],
    continents: ["North America"],
    countries: ["Barbados", "St Kitts", "St Maarten", "St Thomas"],
    cities: [],
    public: false
  },
  {
    id: "2017-in-pictures",
    name: "2017 In Pictures",
    thumb: "2017.jpeg",
    url: "https://onedrive.live.com/?view=8&photosData=%2Falbum%2F3441A0B7058E365B%21111917",
    date: new Date("2017-12-31"),
    labels: ["retrospective"],
    continents: [],
    countries: [],
    cities: [],
    public: false
  },
  {
    id: "great-barrier-reef",
    name: "Great Barrier Reef",
    thumb: "barrierreef.jpeg",
    url: "https://onedrive.live.com/?view=8&photosData=%2Falbum%2F3441A0B7058E365B%21111930",
    date: new Date("2017-10-22"),
    labels: ["nature"],
    continents: ["Oceania"],
    countries: ["Australia"],
    cities: ["Great Barrier Reef"],
    public: true
  },
  {
    id: "melbourne-street-art",
    name: "Melbourne Street Art",
    thumb: "melstreetart.jpeg",
    url: "https://onedrive.live.com/?view=8&photosData=%2Falbum%2F3441A0B7058E365B%21111927",
    date: new Date("2017-10-25"),
    labels: ["street art", "art"],
    continents: ["Oceania"],
    countries: ["Australia"],
    cities: ["Melbourne"],
    public: true
  },
  {
    id: "2016-in-pictures",
    name: "2016 In Pictures",
    thumb: "2016.jpeg",
    url: "https://onedrive.live.com/?view=8&photosData=%2Falbum%2F3441A0B7058E365B%21111899",
    date: new Date("2016-12-31"),
    labels: ["retrospective"],
    continents: [],
    countries: [],
    cities: [],
    public: false
  },
  {
    id: "dubai",
    name: "Dubai",
    thumb: "dubai.jpeg",
    url: "https://onedrive.live.com/?view=8&photosData=%2Falbum%2F3441A0B7058E365B%21111931",
    date: new Date("2016-04-26"),
    labels: [],
    continents: ["Asia", "Africa"],
    countries: ["United Arab Emirates"],
    cities: ["Dubai"],
    public: false
  },
  {
    id: "kruger",
    name: "Kruger",
    thumb: "kruger.jpeg",
    url: "https://onedrive.live.com/?view=8&photosData=%2Falbum%2F3441A0B7058E365B%21111898",
    date: new Date("2016-01-02"),
    labels: ["nature"],
    continents: ["Africa"],
    countries: ["South Africa"],
    cities: [],
    public: true
  },
  {
    id: "2015-in-pictures",
    name: "2015 In Pictures",
    thumb: "2015.jpeg",
    url: "https://onedrive.live.com/?view=8&photosData=%2Falbum%2F3441A0B7058E365B%21111909",
    date: new Date("2015-12-31"),
    labels: ["retrospective"],
    continents: [],
    countries: [],
    cities: [],
    public: false
  },
  {
    id: "croatia-and-montenegro",
    name: "Croatia and Montenegro",
    thumb: "croatia2015.jpeg",
    url: "https://onedrive.live.com/?view=8&photosData=%2Falbum%2F3441A0B7058E365B%21111910",
    date: new Date("2015-09-12"),
    labels: [],
    continents: ["Europe"],
    countries: ["Croatia"],
    cities: [],
    public: false
  },
  {
    id: "dismaland",
    name: "Dismaland",
    thumb: "dismaland.jpeg",
    url: "https://onedrive.live.com/?view=8&photosData=%2Falbum%2F3441A0B7058E365B%21111934",
    date: new Date("2015-08-28"),
    labels: ["art"],
    continents: ["Europe"],
    countries: ["England"],
    cities: [],
    public: true
  },
  {
    id: "chitwan",
    name: "Chitwan",
    thumb: "chitwan.jpeg",
    url: "https://onedrive.live.com/?view=8&photosData=%2Falbum%2F3441A0B7058E365B%21111933",
    date: new Date("2015-04-05"),
    labels: [],
    continents: ["Asia"],
    countries: ["Nepal"],
    cities: ["Chitwan"],
    public: false
  },
  {
    id: "kathmandu",
    name: "Kathmandu",
    thumb: "kathmandu.jpeg",
    url: "https://onedrive.live.com/?view=8&photosData=%2Falbum%2F3441A0B7058E365B%21111932",
    date: new Date("2015-04-04"),
    labels: [],
    continents: ["Asia"],
    countries: ["Nepal"],
    cities: ["Kathmandu"],
    public: false
  },
  {
    id: "2014-in-pictures",
    name: "2014 In Pictures",
    thumb: "2014.jpeg",
    url: "https://onedrive.live.com/?view=8&photosData=%2Falbum%2F3441A0B7058E365B%21111921",
    date: new Date("2014-12-31"),
    labels: ["retrospective"],
    continents: [],
    countries: [],
    cities: [],
    public: false
  },
  {
    id: "london-street-art",
    name: "London Street Art",
    thumb: "londonstreetart.jpeg",
    url: "https://onedrive.live.com/?view=8&photosData=%2Falbum%2F3441A0B7058E365B%21111916",
    date: new Date("2014-08-30"),
    labels: ["street art", "art"],
    continents: ["Europe"],
    countries: ["England"],
    cities: ["London"],
    public: true
  },
  {
    id: "2013-in-pictures",
    name: "2013 In Pictures",
    thumb: "2013.jpeg",
    url: "https://onedrive.live.com/?view=8&photosData=%2Falbum%2F3441A0B7058E365B%21111922",
    date: new Date("2013-12-31"),
    labels: ["retrospective"],
    continents: [],
    countries: [],
    cities: [],
    public: false
  },
  {
    id: "sweden-ice-hotel",
    name: "Sweden Ice Hotel",
    thumb: "swedenicehotel.jpeg",
    url: "https://onedrive.live.com/?view=8&photosData=%2Falbum%2F3441A0B7058E365B%21111923",
    date: new Date("2013-12-30"),
    labels: ["sweden", "Sweden"],
    continents: ["Europe"],
    countries: [],
    cities: [],
    public: true
  },
  {
    id: "munich",
    name: "Munich",
    thumb: "munich.jpeg",
    url: "https://onedrive.live.com/?view=8&photosData=%2Falbum%2F3441A0B7058E365B%21111924",
    date: new Date("2013-10-19"),
    labels: [],
    continents: ["Europe"],
    countries: ["Germany"],
    cities: ["Munich"],
    public: false
  },
  {
    id: "bangkok",
    name: "Bangkok",
    thumb: "bangkok.jpeg",
    url: "https://onedrive.live.com/?view=8&photosData=%2Falbum%2F3441A0B7058E365B%21111925",
    date: new Date("2013-05-05"),
    labels: [],
    continents: ["Asia"],
    countries: ["Thailand"],
    cities: ["Bangkok"],
    public: false
  },
  {
    id: "las-vegas-neon-museum",
    name: "Las Vegas Neon Museum",
    thumb: "lvneon.jpeg",
    url: "https://onedrive.live.com/?view=8&photosData=%2Falbum%2F3441A0B7058E365B%21111914",
    date: new Date("2012-12-31"),
    labels: ["art"],
    continents: ["North America"],
    countries: ["United States"],
    cities: ["Las Vegas"],
    public: true
  },
  {
    id: "grand-canyon",
    name: "Grand Canyon",
    thumb: "grandcanyon.jpeg",
    url: "https://onedrive.live.com/?view=8&photosData=%2Falbum%2F3441A0B7058E365B%21111915",
    date: new Date("2012-12-30"),
    labels: [],
    continents: ["North America"],
    countries: ["United States"],
    cities: ["Las Vegas"],
    public: true
  },
  {
    id: "jaipur",
    name: "Jaipur",
    thumb: "jaipur.jpeg",
    url: "https://onedrive.live.com/?view=8&photosData=%2Falbum%2F3441A0B7058E365B%21111937",
    date: new Date("2012-11-22"),
    labels: ["india", "India"],
    continents: ["Asia"],
    countries: [],
    cities: ["Jaipur"],
    public: false
  },
  {
    id: "taj-mahal",
    name: "Taj Mahal",
    thumb: "tajmahal.jpeg",
    url: "https://onedrive.live.com/?view=8&photosData=%2Falbum%2F3441A0B7058E365B%21111936",
    date: new Date("2012-11-21"),
    labels: ["india", "India"],
    continents: ["Asia"],
    countries: [],
    cities: [],
    public: true
  },
  {
    id: "london-olympics-2012",
    name: "London Olympics 2012",
    thumb: "londonolympics.jpeg",
    url: "https://onedrive.live.com/?view=8&photosData=%2Falbum%2F3441A0B7058E365B%21111935",
    date: new Date("2012-09-06"),
    labels: ["sport"],
    continents: ["Europe"],
    countries: ["England"],
    cities: ["London"],
    public: false
  },
  {
    id: "easter-island",
    name: "Easter Island",
    thumb: "easterisland.jpeg",
    url: "https://onedrive.live.com/?view=8&photosData=%2Falbum%2F3441A0B7058E365B%21111919",
    date: new Date("2011-10-24"),
    labels: [],
    continents: ["South America"],
    countries: ["Chile"],
    cities: ["Easter Island"],
    public: false
  },
  {
    id: "ba-street-art",
    name: "Buenos Aires Street Art",
    thumb: "bastreetart.jpeg",
    url: "https://onedrive.live.com/?view=8&photosData=%2Falbum%2F3441A0B7058E365B%21111920",
    date: new Date("2011-11-05"),
    labels: ["street art", "art"],
    continents: ["South America"],
    countries: ["Argentina"],
    cities: ["Buenos Aires"],
    public: true
  },
  {
    id: "cairo",
    name: "Cairo",
    thumb: "cairo.jpeg",
    url: "https://onedrive.live.com/?view=8&photosData=%2Falbum%2F3441A0B7058E365B%21111913",
    date: new Date("2011-04-30"),
    labels: ["egypt", "Egypt"],
    continents: ["Africa"],
    countries: [],
    cities: [],
    public: false
  },
  {
    id: "hanoi",
    name: "Hanoi",
    thumb: "hanoi.jpeg",
    url: "https://onedrive.live.com/?view=8&photosData=%2Falbum%2F3441A0B7058E365B%21111940",
    date: new Date("2010-10-15"),
    labels: [],
    continents: ["Asia"],
    countries: ["Vietnam"],
    cities: ["Hanoi"],
    public: false
  },
  {
    id: "angkor-wat",
    name: "Angkor Wat",
    thumb: "angkor.jpeg",
    url: "https://onedrive.live.com/?view=8&photosData=%2Falbum%2F3441A0B7058E365B%21111939",
    date: new Date("2010-10-13"),
    labels: [],
    continents: ["Asia"],
    countries: ["Cambodia"],
    cities: [],
    public: false
  },
  {
    id: "iceland",
    name: "Iceland",
    thumb: "iceland.jpeg",
    url: "https://onedrive.live.com/?view=8&photosData=%2Falbum%2F3441A0B7058E365B%21111941",
    date: new Date("2010-05-01"),
    labels: ["iceland", "Iceland"],
    continents: ["Europe"],
    countries: [],
    cities: [],
    public: false
  },
  {
    id: "xi-an",
    name: "Xi An",
    thumb: "xian.jpeg",
    url: "https://onedrive.live.com/?view=8&photosData=%2Falbum%2F3441A0B7058E365B%21111942",
    date: new Date("2008-05-18"),
    labels: [],
    continents: ["Asia"],
    countries: ["China"],
    cities: [],
    public: false
  },
  {
    id: "great-wall-of-china",
    name: "Great Wall of China",
    thumb: "wallchina.jpeg",
    url: "https://onedrive.live.com/?view=8&photosData=%2Falbum%2F3441A0B7058E365B%21111943",
    date: new Date("2008-05-16"),
    labels: [],
    continents: ["Asia"],
    countries: ["China"],
    cities: [],
    public: false
  },
  {
    id: "hong-kong",
    name: "Hong Kong",
    thumb: "hongkong.jpeg",
    url: "https://onedrive.live.com/?view=8&photosData=%2Falbum%2F3441A0B7058E365B%21111944",
    date: new Date("2008-05-12"),
    labels: [],
    continents: ["Asia"],
    countries: ["Hong Kong"],
    cities: [],
    public: false
  },
  {
    id: "japan",
    name: "Japan",
    thumb: "japan.jpeg",
    url: "https://onedrive.live.com/?view=8&photosData=%2Falbum%2F3441A0B7058E365B%21111928",
    date: new Date("2006-05-30"),
    labels: [],
    continents: ["Asia"],
    countries: ["Japan"],
    cities: [],
    public: false
  }
];